import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Responsiveness = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M7.243 3.414 5.828 2 3 4.828l1.414 1.415 2.829-2.829ZM14 2h-4v2h1v1.062a8.001 8.001 0 0 0-.162 15.854l.288-1.979A6.002 6.002 0 0 1 12 7a6 6 0 0 1 3 11.198V15h-2v6h7v-2h-2.707A8.001 8.001 0 0 0 13 5.062V4h1V2Z"
      fill="currentColor"
    />
    <path
      d="M15.95 10.414 14.536 9 11 12.536l1.414 1.414 3.536-3.536ZM19.828 6.243l1.415-1.415L18.414 2 17 3.414l2.828 2.829Z"
      fill="currentColor"
    />
  </Icon>
));

export default Responsiveness;
